import { Color } from './color';
/**
 * A filled path.
 */
export const Path = (options) => {
    return Color(Object.assign({ colorAttribute: 'fill' }, options));
};
Path.props = {
    defaultEnterAnimation: 'fadeIn',
    defaultUpdateAnimation: 'morphing',
    defaultExitAnimation: 'fadeOut',
};
//# sourceMappingURL=path.js.map